import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    HostListener
  } from '@angular/core'
  import { ModalStateService } from 'src/app/core/services/modal-state.service'
  import { FormGroup, Validators, FormControl } from '@angular/forms'
  import { OptionsStore } from '../modal-options/options-utils/options-store'
  //import { SharedDataService } from 'src/app/services/shared-data.service'
//import { ApplicantInfo } from '../../../helpers/interfaces'
import { ModalPopupsService } from '../modal-options/modal-popups.service'
//import {TranslateService} from '@ngx-translate/core'
import { ApiService } from 'src/app/core/services/api.service'
import { LayoutService } from '../../../core/services/layout.service'
import { NGXLogger } from 'ngx-logger'
import {
  mobileHyphensComplete,
} from 'src/app/core/helpers/app-link'
import { SharedDataService } from 'src/app/core/services/shared-data.service'

import {firstValueFrom} from 'rxjs';
import { environment } from '../../../../environments/environment'


  @Component({
    selector: 'web-prequal-options-get-phonenumber',
    templateUrl: './web-prequal-options-get-phonenumber.component.html',
    styleUrls: ['./web-prequal-options-get-phonenumber.component.scss'],
    standalone: false
})
  export class WebPreQualOptionsGetPhoneNumberComponent implements OnInit {
    @Output() letsGetPhoneNumberSubmit: EventEmitter<any> = new EventEmitter()
 //   @Output() toggleLoader: EventEmitter<any> = new EventEmitter()
    @Input() FULL_DEV: any = false
    @Input() isWebAppGetPhoneNumber = true
    @Input() breakpoints: any = {
      extraSmall: false,
      small: false,
      medium: false,
      large: true,
      extraLarge: true,
    }
    AMOUNT_REGEX = /^\$?[1-9][0-9\,]+$/
    showMask: boolean;
    showDollar: boolean;
    showErrMsg: boolean = false
    showHeader = false
    showFooter = false

    showLoader: boolean = false
    app_store_url: string = environment.iOS_APPSTORE
    play_store_url: string = environment.ANDROID_PLAYSTORE

    getPhoneNumberForm = new FormGroup({
      mobile: new FormControl('', [Validators.required,  Validators.pattern(/^\d{3}-\d{3}-\d{4}$/)]),
    });



    contentHeigt = 0
    @HostListener('window:resize', ['$event'])
      onResize(event) {
        this.contentHeigt = (window.innerHeight);
    

      }
  
    
  public store: OptionsStore
   constructor(
      public modalStateService: ModalStateService,
     // public sharedDataService: SharedDataService,
      public modalPopupsService: ModalPopupsService,
     // private translate: TranslateService,
      public sharedDataService: SharedDataService,
      private layoutService: LayoutService,
      private api: ApiService,
      public logger: NGXLogger,
    ) {
      this.contentHeigt = (window.innerHeight);
       }
  
    prefillHit: any = false
    isWelcomeBack= false
    //applicantInfo: ApplicantInfo
    languageSelected: any
    welcomeUser =''
    dlToken=''

    ngOnInit(): void {
        this.layoutService.subscribeToLayoutChanges().subscribe(
          (observerResponse : any) => {
            this.breakpoints = this.layoutService.handleLayoutChanges()
          },
          (error: any) => {
            console.error(error)
          }
        )
      }
  
    public async onGetPhoneNumberSubmit(): Promise<void> {
     
      if (this.getPhoneNumberForm.invalid) {
        this.showLoader = false
        this.showErrMsg = true
        setTimeout(() => {
          this.showErrMsg = false
        }, 2000);
      }
      this.getPhoneNumberForm.markAllAsTouched()
      if (this.getPhoneNumberForm.valid) {
        this.showLoader = true
        const mobileNumber = this.getPhoneNumberForm.controls.mobile.value?.replace(/-/g, "")
        this.probeLanding(mobileNumber)
      }

    }


   private async probeLanding(phoneNumber : string){
      try {
            const res: any = await firstValueFrom(this.api.getProbeLanding(phoneNumber))
         if (res?.data) {
            console.log('ProbeLanding:  '+ JSON.stringify(res?.data))
           switch (res?.data?.isUserRegistered) {
             case true:
               console.log("User Already Registered.")
               this.navigate()
               break;
             case false:
               if (res?.data?.nextStep !== null && !res?.data?.isUserRegistered) {
                 console.log("User Coming Back.")
                 this.showLoader = false
                 window.location.href = res?.data?.deepLink
               } else if (res?.data?.nextStep === null && !res?.data?.isUserRegistered && !res?.data?.applicationResumeLink) {
                 console.log("User is OON.")
                 this.navigate()
               }
               break;
             default:
               console.log("Default")
               this.navigate()
               break;
           }
          
        }
      } catch (err) {
        this.logger.error(err)
        this.showLoader = false
      }
     }


    navigate() {
      if ((/Android/i.test(navigator.userAgent))) {
        this.showLoader = false
        window.location.href = this.play_store_url
      }
      if (/iPad|iPhone|iPod/i.test(navigator.userAgent)) {
        setTimeout(() => {
          this.showLoader = false
          window.open(this.app_store_url, '_blank');
        }, 500);
      }
    }

    numberOnly(event): boolean {
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    }

    getMargin(){
      return `${this.contentHeigt - 340}px auto 0px auto`
    }

    onMobileInput(e) {
      mobileHyphensComplete(e, e.target)
    }

  }
